import { FocusRail, type FocusRailItem } from "./focus-rail";

const DEMO_ITEMS: FocusRailItem[] = [
  {
    id: 1,
    title: "Dashboard de Produtividade",
    description:
      "Visão geral do seu desempenho diário com métricas de foco, sessões e progresso. Essencial para tomada de decisão e ajuste da rotina de estudos.",
    meta: "Produtividade • Controle",
    imageSrc: "/images/dashboard.webp",
    href: "#dashboard",
  },
  {
    id: 2,
    title: "Progresso por Disciplina",
    description:
      "Acompanhamento detalhado da evolução em cada disciplina, permitindo identificar pontos fortes e fracos. Fundamental para aprendizagem baseada em dados.",
    meta: "Análise • Evolução",
    imageSrc: "/images/progresso.webp",
    href: "#progresso",
  },
  {
    id: 3,
    title: "Histórico de Estudos",
    description:
      "Registro completo das sessões realizadas. Ajuda a criar consistência e reforça o aprendizado por meio da repetição e revisão.",
    meta: "Consistência • Revisão",
    imageSrc: "/images/historico.webp",
    href: "#historico",
  },
  {
    id: 4,
    title: "Gestão de Disciplinas",
    description:
      "Organização das matérias e conteúdos. Permite estruturar o plano de estudos de forma clara, melhorando a retenção e o planejamento.",
    meta: "Organização • Planejamento",
    imageSrc: "/images/disciplinas.webp",
    href: "#disciplinas",
  },
  {
    id: 5,
    title: "Sistema de Progresso e Métricas",
    description:
      "Indicadores como taxa de acerto, tempo estudado e módulos concluídos. Essenciais para feedback contínuo e aprendizagem adaptativa.",
    meta: "Métricas • Performance",
    imageSrc: "/images/metricas.webp",
    href: "#metricas",
  },
];

export function FocusRailDemo() {
  return (
    <FocusRail items={DEMO_ITEMS} autoplay interval={8000} />
  );
}
